module.exports = __webpack_public_path__ + "img/fun-5.059fda41.png";